
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useEmbeddingsSetup = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  // Use a specific type union instead of string
  const checkEmbeddingColumn = async (table: "candidates" | "jobs" | "companies"): Promise<boolean> => {
    try {
      // Try to query the embedding column
      const { error } = await supabase
        .from(table)
        .select('embedding')
        .limit(1);

      // If there's no error, the column exists
      if (!error) {
        return true;
      }

      // Check if the error indicates the column doesn't exist
      if (error.message.includes('does not exist')) {
        return false;
      }

      // For any other errors, throw them
      throw error;
    } catch (error) {
      console.error(`Error checking embedding column for ${table}:`, error);
      return false;
    }
  };

  return {
    checkEmbeddingColumn,
    isLoading
  };
};
